import React, { FC, useEffect, useState } from "react";
import {
  Wrapper,
  HeaderText,
  BodyWrapper,
  LoaderWrapper,
  CalendarWrapper,
  DateWrapper,
  ButtonStyled,
} from "./elements";
import Calendar from "@chervinvananaz/react-google-calendar";
import { Loader } from "../../atoms/Loader";
import { DatePicker } from "../../atoms/DatePicker";
import moment from "moment";

type Props = {
  apiKey: string;
  calendars: { calendarId: string }[];
};

const MySchedule: FC<Props> = ({ apiKey, calendars }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedMonthYear, setSelectedMonthYear] = useState(moment());

  useEffect(() => {
    setTimeout(() => {
      setShowCalendar(true);
    }, 1000);
  }, []);

  return (
    <Wrapper>
      <HeaderText>My Schedule</HeaderText>
      <BodyWrapper>
        <DateWrapper>
          <DatePicker
            picker="month"
            placeholder="Select Year/Month"
            disabledDate={() => false}
            width={"178px"}
            onChange={(date: string, dateString: string) =>
              setSelectedMonthYear(date as any)
            }
            value={selectedMonthYear}
            formatProp={"YYYY-MM"}
          />
          <ButtonStyled
            type={"default"}
            onClick={() => setSelectedMonthYear(moment())}
          >
            Today
          </ButtonStyled>
        </DateWrapper>
        <CalendarWrapper showCalendar={showCalendar}>
          <Calendar
            apiKey={apiKey}
            calendars={calendars}
            showFooter={false}
            selectedMonthYear={selectedMonthYear}
            updatedMonthYear={(monthYear: any) =>
              setSelectedMonthYear(moment(monthYear.toDate()))
            }
          />
        </CalendarWrapper>
        {!showCalendar && (
          <LoaderWrapper>
            <Loader />
          </LoaderWrapper>
        )}
      </BodyWrapper>
    </Wrapper>
  );
};

export default MySchedule;
